module.exports = __WEBPACK_EXTERNAL_MODULE_36__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 36
// module chunks = 9